import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import DashboardPage from './components/DashboardPage';
import SubscriptionsPage from './components/SubscriptionsPage';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/subscriptions" element={<SubscriptionsPage />} />
        <Route path="/error" element={
          <div className="min-h-screen bg-base-200 flex items-center justify-center">
            <div className="card bg-base-100 shadow-xl">
              <div className="card-body text-error">
                <h2 className="card-title">Authentication Error</h2>
                <p>Failed to authenticate with Twitch. Please try again.</p>
              </div>
            </div>
          </div>
        } />
      </Routes>
    </Router>
  );
};

export default App; 